import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import id from './locales/id/translation.json';

const savedLang = localStorage.getItem('lang');
// Synchronous browser locale detection — used as immediate default to avoid English flash
const browserLang = navigator.language?.startsWith('id') ? 'id' : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    id: { translation: id },
  },
  lng: savedLang || browserLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// Refine with IP detection if no saved preference (more accurate than browser locale alone)
if (!savedLang) {
  refineWithIPDetection();
}

async function refineWithIPDetection() {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    const lang = data.country_code === 'ID' ? 'id' : 'en';
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
  } catch {
    // Browser locale already applied as default, just persist it
    localStorage.setItem('lang', browserLang);
  }
}

export default i18n;
